import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../public/LandingPage.css';
import './Login.css';

const ResetPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    const { resetPassword } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await resetPassword(email);
            setEmailSent(true);
        } catch (err) {
            console.error('Reset password error:', err);
            setError(err.message || 'Failed to send reset email. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page-wrapper">
            {/* Header */}
            <header className="landing-header">

                <div className="header-container">
                    <div className="logo-section">
                        <img src="/lareg_logo.png" alt="TCE Logo" className="tce-logo" />
                    </div>

                    <nav className="header-nav">
                        <a href="/" className="nav-link">Home</a>
                        <a href="/home#about" onClick={(e) => { e.preventDefault(); window.location.href = '/home#about'; }} className="nav-link">About TRF</a>
                        <a href="/home#eligibility" onClick={(e) => { e.preventDefault(); window.location.href = '/home#eligibility'; }} className="nav-link">Eligibility</a>
                        <a href="/home#guidelines" onClick={(e) => { e.preventDefault(); window.location.href = '/home#guidelines'; }} className="nav-link">Guidelines</a>
                        <a href="#footer" className="nav-link">Contact</a>
                        <button onClick={() => navigate('/login')} className="login-btn">
                            Login
                        </button>
                    </nav>
                </div>
            </header>

            {/* Reset Password Form Section */}
            <div className="login-content">
                <div className="login-card">
                    {!emailSent ? (
                        <>
                            <div className="login-header">
                                <h1 className="login-title">Reset Password</h1>
                                <p className="login-subtitle">
                                    Enter your email address and we'll send you a link to reset your password.
                                </p>
                            </div>

                            {error && (
                                <div className="login-error">
                                    {error}
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                <div className="login-form-group">
                                    <label className="login-form-label">Email Address</label>
                                    <div className="input-with-icon">
                                        <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <input
                                            type="email"
                                            className="login-form-input with-icon"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            placeholder="Enter your email"
                                        />
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="login-submit-btn"
                                    style={{
                                        background: loading ? '#9ca3af' : 'linear-gradient(135deg, #818cf8 0%, #6366f1 100%)'
                                    }}
                                >
                                    {loading ? 'Sending...' : 'Send Reset Link'}
                                </button>
                            </form>

                            <div className="back-to-login">
                                <a href="/login" className="back-link">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    Back to Login
                                </a>
                            </div>
                        </>
                    ) : (
                        <div className="success-message">
                            <div className="success-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="10" stroke="#10b981" strokeWidth="2" />
                                    <path d="M8 12L11 15L16 9" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h2 className="success-title">Email Sent!</h2>
                            <p className="success-description">
                                Check your email for password reset instructions.
                            </p>
                            <div className="success-warning">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <div>
                                    <strong>Important:</strong> Please check all your email folders including{' '}
                                    <strong>Spam</strong>, <strong>Promotions</strong>, and <strong>Updates</strong>{' '}
                                    folders as the reset link may appear there.
                                </div>
                            </div>
                            <div className="back-to-login" style={{ marginTop: '2rem' }}>
                                <a href="/login" className="back-link">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    Back to Login
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Footer */}
            <footer id="footer" className="landing-footer">
                <div className="footer-container">
                    <div className="footer-content">
                        <div className="footer-section">
                            <h4>Thiagarajar College of Engineering</h4>
                            <p>Madurai - 625 015, Tamil Nadu, India</p>
                        </div>
                        <div className="footer-section">
                            <h4>Contact</h4>
                            <p>Email: <a href="mailto:research@tce.edu">research@tce.edu</a></p>
                            <p>Phone: <a href="tel:+914522482240">+91 452 2482240</a></p>
                            <p>Web: <a href="https://www.tce.edu" target="_blank" rel="noopener noreferrer">www.tce.edu</a></p>
                        </div>
                        <div className="footer-section">
                            <h4>Quick Links</h4>
                            <p><a href="/">Home</a></p>
                            <p><a href="/#about">About TRF</a></p>
                            <p><a href="/#eligibility">Eligibility</a></p>
                            <p><a href="/#guidelines">Guidelines</a></p>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <p>Copyright © 2026 Thiagarajar College of Engineering. All Rights Reserved.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default ResetPassword;
